import { type FC, type ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface StatusLineProps {
  label: string;
  children: ReactNode;
  className?: string;
}

const StatusLine: FC<StatusLineProps> = ({ label, children, className = '' }) => (
  <div className={cn('text-xs flex gap-1', className)}>
    <span className="font-normal">{label}</span>
    {children}
  </div>
);
export default StatusLine;
